module.exports = function (text) {
  return new Error("Runtime error: ".concat(text));
};